// extracted by mini-css-extract-plugin
export default {"header__title":"style_header__title__SLQtj","header__description":"style_header__description__1z8hG","header__menuItem":"style_header__menuItem__0T2ea"};